import { render } from "./LoginPage.vue?vue&type=template&id=68bd05a9"
import script from "./LoginPage.vue?vue&type=script&lang=js"
export * from "./LoginPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/giulio/Documents/Sviluppo/chen/categoria/test-pwa-serverless/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__